/** Word-style table caption numbering for native PDF export. */

const CAPTION_SMALL_WORDS = new Set([
  'a', 'an', 'the', 'and', 'or', 'but', 'of', 'in', 'on', 'for', 'to', 'with', 'at', 'by',
]);

export function mainSectionNumberFromTitle(title) {
  const m = String(title || '').match(/^(\d+)/);
  return m ? m[1] : '1';
}

export function toTitleCaseTableCaption(s) {
  const words = String(s ?? '').trim().split(/\s+/).filter(Boolean);
  return words
    .map((w, i) => {
      const lower = w.toLowerCase();
      if (i > 0 && CAPTION_SMALL_WORDS.has(lower)) return lower;
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(' ');
}

export function extractPdfTableDescription(sectionTitle, tableIndex = 1, firstHeaderText = '') {
  const stripLeadingNumber = (title) => {
    if (!title) return '';
    let t = String(title).trim().replace(/^\d+(?:\.\d+)*\.?\s+/, '');
    return t.replace(/^[:\-\.\s]+/, '').trim();
  };

  if (sectionTitle && String(sectionTitle).trim()) {
    return stripLeadingNumber(sectionTitle);
  }
  const header = String(firstHeaderText || '').trim();
  if (header && header.length < 100) return header;
  return `Table ${tableIndex}`;
}

export function buildTableCaption(mainSection, ordinal, description) {
  const label = `Table ${mainSection}-${ordinal}:`;
  const title = toTitleCaseTableCaption(description);
  return { label, title, mainSection, ordinal };
}

/** Tracks per-section table ordinals during a PDF render pass. */
export function createTableCaptionTracker() {
  const ordinalByMain = {};
  return {
    next(sectionTitle, description) {
      const main = mainSectionNumberFromTitle(sectionTitle);
      ordinalByMain[main] = (ordinalByMain[main] || 0) + 1;
      const ordinal = ordinalByMain[main];
      return buildTableCaption(main, ordinal, description);
    },
  };
}
